var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("PageHeader", {
        attrs: {
          noPadding: "",
          title: "Monthly Water Quality Report",
          icon: "poll",
        },
      }),
      _vm._v(" "),
      _vm.globalIsLoading
        ? _c("v-progress-linear", { attrs: { indeterminate: "" } })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-alert",
        {
          attrs: {
            type: "info",
            value:
              !_vm.globalIsLoading && _vm.reportVisibilityOption.length == 0,
          },
        },
        [
          _vm._v(
            "\n    There are no report types activated for this tenant.\n    Please contact the system administrator to activate reports.\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _vm.selectedReport === null && !_vm.globalIsLoading
        ? [
            _vm.reportTypeIsVisible(_vm.reportObjects.wqMonthly.configKey)
              ? _c(
                  "v-card",
                  [
                    _c("v-card-title", { staticClass: "headline" }, [
                      _vm._v("\n        Summary Report\n      "),
                    ]),
                    _vm._v(" "),
                    _c("v-card-text", { staticClass: "pt-0" }, [
                      _vm._v(
                        "\n        Summary report for surface water, process water and groundwater.\n        "
                      ),
                      _c("br"),
                      _vm._v("\n        Contains most analytes.\n      "),
                    ]),
                    _vm._v(" "),
                    _c(
                      "v-card-text",
                      [
                        _c(
                          "v-layout",
                          [
                            _c(
                              "v-flex",
                              { attrs: { sm6: "", md3: "" } },
                              [
                                _c("v-select", {
                                  attrs: {
                                    solo: "",
                                    items: _vm.monthlyReportSelectItems,
                                    label: "Select Month:",
                                    "return-object": "",
                                    "single-line": "",
                                    "menu-props": "bottom",
                                    "item-text": "text",
                                    disabled:
                                      !_vm.monthlyReportSelectItems.length,
                                    loading: _vm.isLoadingMonthYearList,
                                  },
                                  model: {
                                    value: _vm.selectedReportMonthYear,
                                    callback: function ($$v) {
                                      _vm.selectedReportMonthYear = $$v
                                    },
                                    expression: "selectedReportMonthYear",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("v-divider"),
                    _vm._v(" "),
                    _c(
                      "v-card-actions",
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              loading: _vm.loadingDownloadMonthlyReport,
                              color: "info",
                              disabled: !_vm.selectedReportMonthYear.year,
                            },
                            on: { click: _vm.downloadMonthlyReport },
                          },
                          [
                            _c("v-icon", { staticClass: "mr-1" }, [
                              _vm._v("save_alt"),
                            ]),
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("Button.Download")) +
                                "\n        "
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.reportTypeIsVisible(_vm.reportObjects.bcMoeMonthly.configKey)
              ? _c(
                  "v-card",
                  { staticClass: "mt-3" },
                  [
                    _c("v-card-title", { staticClass: "headline" }, [
                      _vm._v("\n        BC MOE Summary Report\n      "),
                    ]),
                    _vm._v(" "),
                    _c("v-card-text", { staticClass: "pt-0" }, [
                      _vm._v(
                        "\n        BC MOE summary report for surface water, process water and groundwater.\n        "
                      ),
                      _c("br"),
                      _vm._v(
                        "\n        Contains analytes required for discharge permit.\n      "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "v-card-text",
                      [
                        _c(
                          "v-layout",
                          [
                            _c(
                              "v-flex",
                              { attrs: { sm6: "", md3: "" } },
                              [
                                _c("v-select", {
                                  attrs: {
                                    solo: "",
                                    items: _vm.monthlyReportBCMoeSelectItems,
                                    label: "Select Month:",
                                    "return-object": "",
                                    "single-line": "",
                                    "menu-props": "bottom",
                                    "item-text": "text",
                                    disabled:
                                      !_vm.monthlyReportBCMoeSelectItems.length,
                                    loading: _vm.isLoadingMonthYearList,
                                  },
                                  model: {
                                    value: _vm.selectedReportBCMoeMonthYear,
                                    callback: function ($$v) {
                                      _vm.selectedReportBCMoeMonthYear = $$v
                                    },
                                    expression: "selectedReportBCMoeMonthYear",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("v-divider"),
                    _vm._v(" "),
                    _c(
                      "v-card-actions",
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              loading: _vm.loadingDownloadBCMoeMonthlyReport,
                              color: "info",
                              disabled: !_vm.selectedReportBCMoeMonthYear.year,
                            },
                            on: { click: _vm.downloadBCMoeMonthlyReport },
                          },
                          [
                            _c("v-icon", { staticClass: "mr-1" }, [
                              _vm._v("save_alt"),
                            ]),
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("Button.Download")) +
                                "\n        "
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("WaterQualityReportsErrorModal", {
        attrs: { data: _vm.errorModalData, loading: _vm.errorModalLoading },
        on: {
          download: _vm.onErrorModalCallback,
          cancel: _vm.onErrorModalClose,
        },
        model: {
          value: _vm.errorModal,
          callback: function ($$v) {
            _vm.errorModal = $$v
          },
          expression: "errorModal",
        },
      }),
      _vm._v(" "),
      _c("ErrorDialog", {
        attrs: { data: _vm.errorDialog.data, title: _vm.errorDialog.title },
        model: {
          value: _vm.errorDialog.show,
          callback: function ($$v) {
            _vm.$set(_vm.errorDialog, "show", $$v)
          },
          expression: "errorDialog.show",
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }